import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { CATEGORIES, http } from "@/lib/api";

const CategoryStrip = () => {
  // Live categories actually containing products (empty categories are hidden)
  const [live, setLive] = useState(null);

  useEffect(() => {
    http
      .get("/categories")
      .then((r) => setLive(new Set(r.data.categories)))
      .catch(() => {});
  }, []);

  const visible = CATEGORIES.filter(
    (c) => c.name === "Top Offers" || live === null || live.has(c.name)
  );

  return (
    <div
      className="bg-white border-b border-[#e0e0e0] fk-shadow sticky top-14 z-40"
      data-testid="category-strip"
    >
      <div className="max-w-[1400px] mx-auto flex items-center gap-2 sm:gap-8 px-3 sm:px-6 py-2.5 overflow-x-auto no-scrollbar">
        {visible.map((c) => {
          const Icon = Icons[c.icon] || Icons.Tag;
          return (
            <Link
              key={c.name}
              to={`/category/${encodeURIComponent(c.name)}`}
              className="group flex flex-col items-center gap-1 min-w-[64px] text-center"
              data-testid={`category-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className="w-10 h-10 rounded-full bg-[#FCEBEA] flex items-center justify-center text-[#C62828] group-hover:bg-[#C62828] group-hover:text-white transition-colors">
                <Icon className="w-5 h-5" />
              </span>
              <span className="text-[12px] font-medium text-[#212121] whitespace-nowrap group-hover:text-[#C62828]">
                {c.name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryStrip;
